import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { SaveTwilioCampaignProfileRequestPayload } from 'types/twilio/campaignProfile';
import {
  FetchTwilioAvailablePhoneNumbersRequestPayload,
  PurchaseTwilioPhoneNumberRequestPayload,
  TwilioAvailablePhoneNumbersHttpResponse,
} from 'types/twilio/twilioAvailablePhoneNumber';
import {
  CreateTwilioBrandRequestPayload,
  TwilioBrandCreationHttpResponse,
  TwilioBrandDetailsHttpResponse,
} from 'types/twilio/twilioBrand';
import {
  CreateTwilioCampaignRequestPayload,
  TwilioCampaignHttpResponse,
} from 'types/twilio/twilioCampaign';
import {
  CreateTwilioCustomerProfileRequestPayload,
  TwilioCustomerProfileEvaluationHttpResponse,
  TwilioCustomerProfileHttpResponse,
} from 'types/twilio/twilioCustomerProfile';
import { GetTwilioIntegrationDetailsResponse } from 'types/twilio/twilioIntegrationDetails';

export const getTwilioIntegrationDetails = (
  businessId: number,
): AxiosPromise<GetTwilioIntegrationDetailsResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/twilio/integration`,
  });
};

export const getTwilioCustomerProfile = (
  businessId: number,
): AxiosPromise<TwilioCustomerProfileHttpResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/twilio/customer-profile`,
  });
};

export const createTwilioCustomerProfile = ({
  businessId,
  data,
}: CreateTwilioCustomerProfileRequestPayload): AxiosPromise<TwilioCustomerProfileHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/customer-profile`,
    data,
  });
};

export const evaluateTwilioCustomerProfile = (
  businessId: number,
  customerProfileId: string,
): AxiosPromise<TwilioCustomerProfileEvaluationHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/customer-profile/evaluate`,
    data: {
      customerProfileId,
    },
  });
};

export const submitTwilioCustomerProfile = (
  businessId: number,
  customerProfileId: string,
): AxiosPromise<TwilioCustomerProfileHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/customer-profile/submit`,
    data: {
      customerProfileId,
    },
  });
};

export const getTwilioBrand = (
  businessId: number,
  brandId: string,
): AxiosPromise<TwilioBrandDetailsHttpResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/twilio/brands/${brandId}`,
  });
};

export const createTwilioBrand = ({
  businessId,
  data,
}: CreateTwilioBrandRequestPayload): AxiosPromise<TwilioBrandCreationHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/brands`,
    data,
  });
};

export const getTwilioCampaign = ({
  businessId,
  campaignId,
  messagingServiceId,
}: {
  businessId: number;
  campaignId: string;
  messagingServiceId: string;
}): AxiosPromise<TwilioCampaignHttpResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/twilio/messaging/${messagingServiceId}/campaigns/${campaignId}`,
  });
};

export const createTwilioCampaign = ({
  businessId,
  data,
}: CreateTwilioCampaignRequestPayload): AxiosPromise<TwilioCampaignHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/campaigns`,
    data,
  });
};

export const saveTwilioCampaignProfile = ({
  businessId,
  campaignProfile,
}: SaveTwilioCampaignProfileRequestPayload): AxiosPromise => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${businessId}/twilio/campaign-profile`,
    data: campaignProfile,
  });
};

export const getAvailablePhoneNumbers = ({
  businessId,
  data,
}: FetchTwilioAvailablePhoneNumbersRequestPayload): AxiosPromise<TwilioAvailablePhoneNumbersHttpResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/phone-numbers/available`,
    data,
  });
};

export const purchasePhoneNumber = ({
  businessId,
  data,
}: PurchaseTwilioPhoneNumberRequestPayload): AxiosPromise<{ success: boolean }> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/twilio/phone-numbers/purchase`,
    data,
  });
};
